import { NavItemBlueprint } from '@backstage/frontend-plugin-api';
import catalogPluginBase from '@backstage/plugin-catalog/alpha';
import CategoryIcon from '@material-ui/icons/Category';

/**
 * Replace stock `nav-item:catalog` (legacy HomeIcon) without duplicating the row.
 *
 * Do not use core-components `CatalogIcon` here: it is `AppIcon id="catalog"`,
 * which resolves to MUI MenuBook and looks oversized
 * next to other sidebar items. The catalog index `page:catalog` uses MUI
 * Category; matching that keeps size and weight consistent.
 */
const catalogNavItemOverride = NavItemBlueprint.makeWithOverrides({
  factory(originalFactory) {
    return originalFactory({
      routeRef: catalogPluginBase.routes.catalogIndex,
      title: 'Catalog',
      icon: CategoryIcon,
    });
  },
});

export const catalogPlugin = catalogPluginBase.withOverrides({
  extensions: [catalogNavItemOverride],
});
